import LeadForm from '../../components/LeadForm'

const Lead = () => (<LeadForm type='createUser'/>);

export default Lead
